import React, { useContext, useState } from "react";
import Layout from "../components/layouts/Layout";
import Sidebar from "../components/Sidebar";
import { Outlet, useLocation } from "react-router";
import ErrorBoundary from "../components/ErrorBoundary";
import Alert from "../components/Alert";
import { StateContext } from "../store/context";
import MobileSidebar from "../components/mobileSideBar";
import Logo from "../static/logo.png";
import DarkLogo from "../static/darkLogo.svg";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import ROUTES from "../setup/routes";

export const _s = "19";

const Dashboard: React.FC = (): React.ReactElement => {
  const { authUser } = useContext(StateContext);
  const [isCollapsed, setIsCollapsed] = useState(false);
  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };
  const navigate = useNavigate();
  const location = useLocation();
  // Compare ("Fundamental Analysis") is the first page getting the dark
  // glass redesign — gate the shell's own background on its route so
  // every other page routed through this shared layout keeps its
  // current (light) look until it gets themed too.
  const isCompareRoute = location.pathname.startsWith(`/${ROUTES.OVERVIEW}`);

  const [darkMode, setDarkMode] = useState(() => {
    const savedTheme = localStorage.getItem("darkMode");
    return savedTheme === "true" || false;
  });

  const goHome = () => {
    // Was window.location.href = HOMEPAGE (a full-page redirect to the
    // public valueit.io marketing site) — the logo now takes a logged-
    // in user back to their own dashboard instead, via client-side
    // navigation to "/", which Sidebar.tsx's own "landed on /" effect
    // resolves to the first allowed item.
    navigate(ROUTES.HOME);
  };

  const handleSignIn = () => {
    navigate(ROUTES.LOGIN);
  };

  return (
    <Layout>
      <div
        // Collapsed state swaps the whole row from the standard 12-track
        // grid onto an explicit 2-track template (a fixed 96px sidebar
        // column + a `1fr` content column) instead of `col-span-1`'s
        // 1/12 share — 1/12 of the container is comfortably wider than
        // this icon-only sidebar needs on most screens, which is what
        // left visible breathing room next to it even after the sidebar
        // box itself was fixed to fill its own track. 96px rather than a
        // tighter 84px — that clipped the currency Select's "LKR" text
        // to "L…" once its own px-2 side margin (see sidebar.theme.css)
        // was added on top of it. `lg:` scoped so mobile's `grid-cols-12`
        // (and MobileSidebar, hidden at `lg` anyway) are untouched;
        // expanded desktop keeps its original grid-cols-12 + col-span-
        // 2/10 proportions exactly as before.
        className={`w-full h-full items-start justify-between grid grid-cols-12 ${
          isCollapsed ? "lg:grid-cols-[96px_1fr] gap-x-2" : "gap-x-3"
        } !relative !z-40 `}
      >
        <div
          className={`hidden lg:block h-full  !max-h-screen !overflow-hidden transition-all duration-300 ${
            isCollapsed ? "col-span-1" : "col-span-3 lg:col-span-2"
          }`}
        >
          <Sidebar
            toggleCollapse={toggleCollapse}
            isCollapsed={isCollapsed}
            setisCollapsed={setIsCollapsed}
          />
        </div>
        <div className="block lg:hidden h-full !max-h-screen !overflow-hidden col-span-0 lg:col-span-2">
          <MobileSidebar />
        </div>
        <div
          className={`!max-h-screen !h-screen   overflow-y-auto bg-white shadow-sm rounded-md shadow-[#1018280F] transition-all duration-300 ${
            isCollapsed
              ? "col-span-12  lg:col-span-1"
              : "col-span-12  lg:col-span-10"
          } ${isCompareRoute ? "vi-cmp-shell" : ""}`}
        >
          <ErrorBoundary />
          <Alert />
          <div
            className={`w-full h-[80px] mb-4 flex lg:hidden p-4 items-start ${
              darkMode ? "bg-[#1d2939]" : "bg-[#eff6ff]"
            }`}
          >
            <div className="w-[100px] h-[60px] ">
              <img
                src={darkMode ? DarkLogo : Logo}
                className="w-full h-full cursor-pointer"
                onClick={goHome}
                alt="Logo"
              />
            </div>
          </div>

          <Outlet />
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;
